export default __webpack_public_path__ + "static/media/weather__app.1090739f.png";